<template>
    <v-dialog
        :value="isOpen"
        scrollable
        max-width="600px"
        transition="slide-y-transition"
        eager
        :persistent="actionLoading"
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    <template>
                        Wybierz komponenty dla montażu
                    </template>
                </h1>
            </v-card-title>

            <v-data-table
                v-model="componentsSelectedToAdd"
                :headers="headers"
                :items="productComponents"
                :mobile-breakpoint="0"
                hide-default-footer
                disable-pagination
                show-select
                name="productComponentsData"
            >
                <template #item.name="{item}">
                    {{ item.calculationProductName }}
                </template>
                <template #item.componentName="{item}">
                    {{ item.component.name }}
                </template>
            </v-data-table>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    :disabled="actionLoading"
                    data-sentry-label="Anuluj"
                    @click="onClose"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    :disabled="componentsSelectedToAdd.length == 0"
                    :loading="actionLoading"
                    data-sentry-label="Zapisz"
                    @click="onSave"
                >
                    Zapisz
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'AddComponentsDialog',
    props: {
        isOpen: {
            type: Boolean
        },
        impositionData: {
            type: Object,
            default: null
        },
        productComponentsData: {
            type: Array,
            default: null
        },
        actionLoading: {
            type: Boolean
        }
    },
    data() {
        return {
            productComponents: [],
            componentsSelectedToAdd: [],
            headers: [
                {
                    text: 'Nazwa własna',
                    value: 'name',
                    sortable: false,
                },
                {
                    text: 'Komponent',
                    value: 'componentName',
                    sortable: false,
                }
            ]
        }
    },
    computed: {
        selectedCalculationProductComponentIds() {
            return this.componentsSelectedToAdd.map(item => item.id)
        }
    },
    watch: {
        isOpen(boolean) {
            if (boolean) {
                this.productComponents = JSON.parse(JSON.stringify(this.productComponentsData))
            } else {
                setTimeout(() => {
                    this.productComponents = []
                    this.componentsSelectedToAdd = []
                }, 500)
            }
        }
    },
    methods: {
        onSave() {
            this.$emit('on-save', this.impositionData, this.selectedCalculationProductComponentIds)
        },
        onClose() {
            if (!this.actionLoading) {
                this.$emit('on-close')
            }
        }
    }
}
</script>
